import React from 'react'
import { Form, Button, Message, Modal, Image, Confirm, Dropdown } from 'semantic-ui-react'
import {createAPIClient} from '../../../../../services/api'
import { connect } from 'react-redux'

const {Field} = Form
const modalStyle = { marginTop: '5%', marginLeft: 'auto', marginRight: 'auto'}
const confirmStyle = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)'
}

class EditForm extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      token: props.editOwnerToken,
      error: false,
      isLoading: false,
      searchQuery: null
    }
  }
  // showConfirm () {
  //   this.setState({openConfirm: true})
  // }
  // handleCancel () {
  //   this.setState({openConfirm: false})
  // }
  // handleConfirm () {
  //   const api = createAPIClient()
  //   api.delete(`/api/teammembers/${this.state.member._id}`)
  //     .then(response => {
  //       this.setState({openConfirm: false})
  //       this.props.finishEditing(true)
  //     })
  //     .catch(error => {
  //       console.log(error)
  //     })
  // }
  cancelEdit () {
    this.props.finishEditing(false)
  }
  onFieldChange (e) {
    const token = this.state.token
    token[e.target.name] = e.target.value
    this.setState({token: token})
  }
  handleChangeTemplates (e, { value }) {
    this.setState({
      token: Object.assign({}, this.state.token, {'templates': value})
    })
  }
  handleSearchChange (e, { searchQuery }) {
    this.setState({ searchQuery })
  }
  onEditFormSubmit () {
    // call the api
    this.setState({isLoading: true})
    const api = createAPIClient()
    const form = {
      owner: this.state.token.owner,
      templates: this.state.token.templates
    }
    api.put(`/api/accesstokens/${this.state.token._id}`, form)
      .then(response => {
        this.setState({isLoading: false})
        this.props.finishEditing(true)
      })
      .catch(error => {
        this.setState({isLoading: false, error: true})
        console.log(error)
      })
  }
  showConfirm () {
    this.props.showConfirm(this.state.token)
    // this.setState({openConfirm: true})
  }
  render () {

    const options = this.props.templates.templates.map(template => {
      return {
        'key': template._id,
        'text': template.name,
        'value': template._id
      }
    })

    const editForm = (
      <div>
        <Form id='editForm' loading={this.state.isLoading} onSubmit={this.onEditFormSubmit.bind(this)}>
          {this.state.error ? (<Message negative>
            <Message.Header>Could not update the owner</Message.Header>
          </Message>) : undefined}

          <Field>
            <label htmlFor='owner'>Owner</label>
            <input autoFocus type='text' id='owner' name='owner' value={this.state.token.owner}
                   onChange={this.onFieldChange.bind(this)} />
          </Field>

          <Field>
            <label>Assigned templates</label>
            <Dropdown
              name='templates'
              fluid
              selection
              multiple
              search
              options={options}
              value={this.state.token.templates}
              placeholder='Select template (omit to assign to all)'
              onChange={this.handleChangeTemplates.bind(this)}
              onSearchChange={this.handleSearchChange.bind(this)}
            />
          </Field>

        </Form>
      </div>
    )
    const modal = (
      <Modal open={this.props.showEditForm} style={modalStyle} onClose={this.cancelEdit.bind(this)}>
        <Modal.Header style={{overflow: 'hidden'}}>
          Edit device
          <a href='#'>
            <Image onClick={this.cancelEdit.bind(this)} style={{float: 'right', fontSize: '12px', verticalAlign: 'middle', lineHeight: '12px'}} avatar src={'/icons/close_432859.svg'} />
          </a>
          <a href='#'>
            <Image onClick={this.showConfirm.bind(this)} style={{float: 'right', fontSize: '12px', verticalAlign: 'middle', lineHeight: '12px', marginRight: '20px'}} avatar src={'/icons/delete_1397562.svg'} />
          </a>
        </Modal.Header>
        <Modal.Content>
          <Modal.Description>
            {editForm}
          </Modal.Description>
        </Modal.Content>
        <Modal.Actions>
          <Button primary icon='check' content='Update' type='submit' form='editForm' />
        </Modal.Actions>
      </Modal>
    )
    return modal
  }
}

function mapStateToProps (state) {
  return {locations: state.account.user.locations, user: state.account.user, templates: state.templates}
}

export default connect(mapStateToProps, {})(EditForm)



// WEBPACK FOOTER //
// ./src/pages/settings/devices/components/edit/index.js